module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/our-story.json
// module id = 381
// module chunks = 172918883569185